import { Navigate, useParams } from "react-router";

/**
 * Alte Auswertungs-Adressen zeigen jetzt auf den Beratermodus.
 *
 * `/contacts/:id/auswertung` (und die Variante mit Token) war eine eigene
 * Seite: Sie breitete alle Felder der Analyse ein zweites Mal zum Bearbeiten
 * aus und trug als einzige den Knopf, der die Angaben tatsächlich in den
 * Kontakt übernimmt. Beides ist in den Fragebogen gewandert — korrigiert wird
 * dort, wo die Frage steht, und übernommen im letzten Schritt („Auswertung &
 * Abschluss").
 *
 * Die Route bleibt als Weiterleitung, weil ihre Adresse in Vorgängen, Mails
 * und Lesezeichen steht. `replace` hält den Zurück-Knopf sauber: Sonst landete
 * man beim Zurückgehen wieder auf der Weiterleitung und würde sofort erneut
 * vorwärts geschickt.
 *
 * Der Token im Pfad wird bewusst nicht mitgereicht. Er zeigte auf die
 * Einreichung EINES Links; die braucht der Beratermodus nicht mehr, weil er
 * die jüngste Kundeneinreichung des Kontakts von sich aus lädt
 * (`getInternalState`, Feld `kundenAntworten`).
 */
const AnalysemodusAuswertungRedirect = () => {
  const { id } = useParams();
  if (!id) return <Navigate to="/contacts" replace />;
  return <Navigate to={`/contacts/${id}/risikoanalyse-step`} replace />;
};

export default AnalysemodusAuswertungRedirect;
